<template>
  <div>
    <v-dialog v-model="isCreating" width="400px">
      <v-card flat>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Create A new Network</span>
          <v-btn text icon dark @click="isCreating = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <NetworkForm :company="company" @added="addNetwork" />
        </v-container>
      </v-card>
    </v-dialog>

    <v-card flat>
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">
          Networks
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn @click="isCreating = true" color="primary" v-if="networks.length < 3">
          <v-icon>mdi-domain-plus </v-icon>
          New
        </v-btn>
      </v-toolbar>
      <tab-filters :tabs="tabs" vertical>
        <v-tab-item v-for="network in networks" :key="network.id">
          <Network :network="network" flat />
        </v-tab-item>
      </tab-filters>
    </v-card>
  </div>
</template>
<script>
import Network from "./network";
import NetworkForm from "./networkForm";
export default {
  components: { Network, NetworkForm },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isCreating: false,
      networks: this.sortByType(this.company.networks),
    };
  },
  methods: {
    sortByType(networks) {
      const order = { "sub-distributor": 1, distributor: 2, aggregator: 3 };

      return networks.sort((a, b) => order[b.type] - order[a.type]);
    },
    addNetwork({ network }) {
      this.isCreating = false;
      Notify.success("Company was added successfully");
      this.networks = this.sortByType(this.networks.concat(network));
    },

    networkIcon() {
      return "mdi-account-group";
    },
  },
  computed: {
    tabs() {
      return this.networks.map((network) => ({
        name: this.titleCase(network.type),
        icon: this.networkIcon(network),
        value: network.type,
      }));
    },
  },
};
</script>
